import { render, staticRenderFns } from "./TodosList.vue?vue&type=template&id=1e1c95d2&scoped=true&"
import script from "./TodosList.vue?vue&type=script&lang=js&"
export * from "./TodosList.vue?vue&type=script&lang=js&"
import style0 from "./TodosList.vue?vue&type=style&index=0&id=1e1c95d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1c95d2",
  null
  
)

export default component.exports